import PropTypes from 'prop-types';
import { ReactComponent as NextIcon } from './assets/ico-arrow-next.svg';

export const Step = ({ onClick, isCompleted = false, i18n, ...step }) => (
  <li className="Summary-step" onClick={onClick} data-testid="step">
    <span
      className={[
        'Summary-title',
        isCompleted && 'Summary-title--completed',
      ].join(' ')}
    >
      {i18n.t(`checkout.LRS.steps.${step.id}`)}
    </span>
    <NextIcon />
  </li>
);

Step.propTypes = {
  i18n: PropTypes.object,
  isCompleted: PropTypes.bool,
  onClick: PropTypes.func,
};
